import Enum from "./Enum";

export default Enum.create( {
	TEAM_TEMPLATES: "TEAM",
	ONE_ON_ONE_TEMPLATES: "ONE_ON_ONES",
	MY_TEMPLATES: "MY_TEMPLATES",
} );
